/** The sidebar's colours: the nav band tokens (--mp-nav-*), so it follows the chosen look (look B has a slate
 *  sidebar). Full class strings, for Tailwind to find. */
export const NAV_BG = 'bg-mp-nav-bg';
export const NAV_TEXT = 'text-mp-nav-text';
/** Inactive rows and secondary text. The nav text is already the band's secondary colour (it reads at AA on the band
 *  in every look), so not dimmed further; the active row and hover use the active pair. */
export const NAV_MUTED = 'text-mp-nav-text';
export const NAV_ACTIVE = 'bg-mp-nav-active-bg text-mp-nav-active-text';
export const NAV_HOVER = 'hover:bg-mp-nav-active-bg hover:text-mp-nav-active-text';
